<template>
  <div>
    <div class="image-wrapper" :class="[heightClass, widthClass]" @click="$refs.fileInput.click()">
      <!-- Preview Image -->
      <img :src="selectedFile" class="rounded w-full" v-if="selectedFile"
       :class="[imgError ? 'object-scale-down' : 'object-cover']"
      @error="imageError($event)" />
      <img
        :src="defaultValue"
        class="rounded w-full"
        v-else-if="defaultValue"
        :class="[imgError ? 'object-scale-down' : 'object-cover']"
        @error="imageError($event)"
      />
      <!-- Edit Image -->
      <div class="edit-icon" v-if="isEditIconShown" @click="selectedFileHandler">
        <edit class="w-full" />
      </div>
      <!-- Upload Image -->
      <div class="upload-image" v-if="!selectedFile && !defaultValue">
        <div>
          <add-photo class="m-auto h-auto" :class="uploadIconSizeClass" />
          <p class="font-semibold text-subtitle">{{ $t('upload_image') }}</p>
          <p class="font-light text-12 mt-1">
            <slot name="description"></slot>
          </p>
        </div>
      </div>
    </div>

    <!-- Hidden upload input -->
    <input
      class="hidden"
      ref="fileInput"
      type="file"
      accept="image/*"
      @change="selectedFileHandler"
    />
  </div>
</template>

<script>
import AddPhoto from '@/assets/icons/vue/add_gallery.vue';
import { OnImageError } from '@/utils/on-image-error';
import Edit from '../assets/icons/vue/edit.vue';

export default {
  name: 'ImageUploader',
  components: { Edit, AddPhoto },
  props: {
    uploadIconSize: {
      type: String,
      default: 'auto',
    },
    height: {
      type: String,
      default: '200',
    },
    width: {
      type: String,
      default: 'full',
    },
    isEditable: {
      type: Boolean,
      default: true,
    },
    isImageRemoved: {
      type: Boolean,
      default: false,
    },
    defaultValue: {
      default: '',
    },
  },
  data() {
    return {
      OnImageError,
      selectedFile: '',
      removeImage: this.isImageRemoved,
      imgError: false,
    };
  },
  watch: {
    isImageRemoved() {
      if (this.isImageRemoved) {
        this.selectedFile = '';
        this.$refs.fileInput.value = '';
      }
    },
  },
  computed: {
    uploadIconSizeClass() {
      return `w-${this.uploadIconSize}`;
    },
    heightClass() {
      return `h-${this.height}`;
    },
    widthClass() {
      return `w-${this.width}`;
    },
    isEditIconShown() {
      return !!(this.isEditable && (this.selectedFile || this.defaultValue));
    },
  },
  methods: {
    imageError($event) {
      this.imgError = true;
      this.OnImageError($event);
    },
    selectedFileHandler() {
      const input = this.$refs.fileInput;
      const file = input.files;
      if (file && file[0]) {
        const reader = new FileReader();
        reader.readAsDataURL(file[0]);
        const imageSize = Math.round(file[0].size / 1024);
        if (imageSize > 10240) {
          this.$toast.error(this.$t('image_size_error'));
          this.$refs.fileInput.value = '';
        } else {
          this.$emit('fileUrl', file[0]);
          reader.onload = (e) => {
            this.selectedFile = e.target.result;
          };
        }
      }
    },
  },
};
</script>

<style lang="css" scoped>
.upload-image {
  @apply flex flex-col items-center justify-center w-full
  text-center border-dashed border-1 border-default h-full
  rounded-sm transition-all duration-300 ease-in-out hover:cursor-pointer;
}
.upload-image:hover {
  background-color: rgba(0, 113, 255, 0.11);
}
.image-wrapper {
  @apply flex-center relative m-auto overflow-hidden rounded-sm;
}
.edit-icon {
  @apply absolute flex-center bg-secondary w-28 rounded-full p-1
    bottom-20 h-28 right-20 hover:cursor-pointer;
}
.flex-center {
    @apply flex items-center justify-center;
  }
</style>
